import { AccessoryBullet } from 'app/components/AccessoryBulletList';

export interface ProductContent {
  description: string[];
  bullets?: AccessoryBullet[];
}

// Every stroller shares the same accessory bullets. The Snack Tray itself is
// promoted out of this list into the PromoCallout, whose content and per-product
// eligibility live entirely in snackTrayPromo.ts (ADR-003/004) — this config
// only owns descriptive copy and bullets.
const STROLLER_BULLETS: AccessoryBullet[] = [
  {
    free: true,
    name: 'drink holder/parent console included',
    note: '(holds up to 3 beverages)',
  },
  {
    free: true,
    name: 'rain cover and cooler bag',
    note: '(available at no charge)',
  },
  {
    free: false,
    name: 'Stroller hook add-ons',
    note: '(limited availability)',
  },
];

// Stroller: real description + the shared accessory bullets.
const strollerEntry = (description: string[]): ProductContent => ({
  description,
  bullets: STROLLER_BULLETS,
});

// Non-stroller (cribs, beds, scooters, special-needs): description only — no
// accessory bullets, no promo.
const descriptionOnly = (description: string[]): ProductContent => ({
  description,
});

export const productContent: Record<number, ProductContent> = {
  1: strollerEntry([
    'The City Mini Single™ is the lightest and most compact of all the singles, making it the perfect park companion.',
  ]),
  2: strollerEntry([
    'The City Mini Double™ is the lightest and most compact of all the doubles, pairing comfort with functionality.',
  ]),
  5: strollerEntry([
    'The BOB Revolution Single™ moves at any pace you can throw at it...perfect for the most active of families.',
  ]),
  6: strollerEntry([
    'The BOB Revolution Duallie™ is the go-to choice for the most adventurous families!',
  ]),
  7: descriptionOnly([
    'Our Foundations™ Full-Sized Folding Crib will be sure to help those little ones not feel so far away from home.',
  ]),
  15: strollerEntry([
    'The Mini GT Single™ is the perfect mid-range stroller combining the compact form of the City Mini with an extended range of height and weight capacity.',
  ]),
  16: strollerEntry([
    'The Mini GT Double™ is the most compact of the larger doubles without sacrificing any of the comfort.',
  ]),
  1023: descriptionOnly([
    "Our Shrunks™ Inflatable Toddler Bed creates a great sleeping environment for children so parents can get a good night's sleep as well.",
  ]),
  1024: descriptionOnly([
    'Our Shrunks™ Inflatable Bed Rails create a barrier to help prevent your child from rolling out of bed.',
  ]),
  2024: strollerEntry([
    'The Summit X3 Single™ combines the easy closing feature of the City Series with the rugged sportiness of the BOB.',
  ]),
  2028: descriptionOnly([
    'The Go-Go Endurance Li, Long Range Mobility Scooter is a perfect way to visit the parks for those with mobility limitations.',
  ]),
  2031: descriptionOnly([
    'The Axiom Lassen 2™ offers those with mobility issues the ability to enjoy every minute of the action.',
    '( Please note: This is a large stroller and is best for those with true mobility issues )',
  ]),
};

export const getProductContent = (
  productId?: number,
): ProductContent | undefined => {
  if (typeof productId !== 'number') return undefined;
  return productContent[productId];
};
